import dayjs from "dayjs";
import getItemStyles from '../../../utils/item-styles.js'
import timelineDisplayOrder from './timelineDisplayOrder.js';
import daylightSavingsCheck from '../../../../../utils/daylightSavingsCheck.js';

/**
 * Returns an assignment item that can be displayed in the 1 to 2 day posted schedule.
 * @param {*} resource
 * @param {*} dayType
 * @param {*} items
 */
const generateAssignments = (resource, dayType, items, timeOffset, scheduleFormat,tourStartTime) => {
  const { rId } = resource;
  const { rdtId } = dayType;
  const { tourId } = dayType.tour;
  const assignments = Object.values(dayType.tour.assignments);
  let adjustedIndex = 0;
  assignments.sort((a, b) => {
    return a.startTime - b.startTime;
  });
  const assignmentArray = [];
  for (let idx in assignments) {
    idx = parseInt(idx, 10);
    const assignValue = assignments[idx];
    const { startTime, endTime, jeId, jobId, requestNumber, costObject, service, status, comment, description, myAssignmentComment, isApproved } = assignValue;
    // time formatting
    const assignStartTime = dayjs(dayjs.unix(startTime).utc().format("YYYY-MM-DD HH:mm:ss"));
    let adjustedAssignStartTime = assignStartTime;
    if(tourStartTime && assignStartTime.isBefore(tourStartTime))
    adjustedAssignStartTime = tourStartTime;
    const assignEndTime = dayjs(dayjs.unix(endTime).utc().format("YYYY-MM-DD HH:mm:ss"));

    let hasComment = false;
    if (comment || description || myAssignmentComment) {
      hasComment = true;
    }

    // determining whether the assignment is on call and thus a unique color or a regular assignment
    let assignmentStyle;
    if (assignValue.jeStatus === '10' || assignValue.status === '10') {
      assignmentStyle = getItemStyles(3);
      adjustedIndex --; // won't count this assignment as a normal color assignment
    } else assignmentStyle = getItemStyles(adjustedIndex);
    const assignment = {
      id: jeId,
      jobId,
      requestNumber,
      itemType: 'assignment',
      group: rId,
      start_time_real: assignStartTime,
      start_time: adjustedAssignStartTime,
      end_time: assignEndTime,
      title: costObject + ' / ' + service,
      rdtId,
      status,
      backgroundColor: assignValue.isApproved ? "gray" : assignmentStyle.backgroundColor,
      color: assignmentStyle.color,
      borderStyle: assignmentStyle.borderStyle,
      borderColor: !hasComment ? assignmentStyle.borderColor : "red",
      timelineDisplayOrder: timelineDisplayOrder.assignment,
      resourceClass: resource.class,
      isApproved
    };
    if (adjustedIndex === 2) {
      adjustedIndex = 0;
    } else adjustedIndex++
    assignmentArray.push(assignment);
  }
  return assignmentArray;
}

export default generateAssignments;
